<template>
	<!-- <div class="container"> -->
		<form @submit.prevent="submitForm" class="d-flex flex-wrap">
				<!-- name -->
				<div class="col-sm-6 col-12 my-2" :class="$i18n.locale === 'en' ? 'pe-0 pe-sm-2' : 'ps-0 ps-sm-2'">
					<input
						v-model="form.name"
						id="name"
						type="text"
						:placeholder="$t('contact-form.form.name')"
						required
						class="w-100 form-radius"
						:class="{ 'activate-validation': fieldErrors.name }"
						@input="fieldErrors.name = false"
						@blur="fieldErrors.name = !form.name"
					>
					<span v-if="fieldErrors.name" class="required-field">{{$t('required-field')}}</span>
				</div>

				<!-- email -->
				<div class="col-sm-6 col-12 my-2" :class="$i18n.locale === 'en' ? 'ps-0 ps-sm-2' : 'pe-0 pe-sm-2'">
					<input
						v-model="form.email"
						id="email"
						type="email"
						:placeholder="$t('contact-form.form.email')"
						required
						class="w-100 form-radius"
						:class="{ 'activate-validation': fieldErrors.email }"
						@input="fieldErrors.email = false"
						@blur="fieldErrors.email = !form.email"
					>
					<span v-if="fieldErrors.email" class="required-field">{{$t('required-field')}}</span>
				</div>

				<!-- phone -->
				<div class="col-sm-6 col-12 my-2" :class="$i18n.locale === 'en' ? 'pe-0 pe-sm-2' : 'ps-0 ps-sm-2'">
					<input
						v-model="form.phone"
						id="phone"
						type="number"
						:placeholder="$t('contact-form.form.phone')"
						required
						class="w-100 form-radius"
						:class="{ 'activate-validation': fieldErrors.phone }"
						@input="fieldErrors.phone = false"
						@blur="fieldErrors.phone = !form.phone"
					>
					<span v-if="fieldErrors.phone" class="required-field">{{$t('required-field')}}</span>
				</div>

				<!-- message type -->
				<div class="col-sm-6 col-12 my-2 position-relative" :class="$i18n.locale === 'en' ? 'ps-0 ps-sm-2' : 'pe-0 pe-sm-2'">
					<input
						v-model="form.messageType"
						readonly
						id="message-type"
						:placeholder="$t('contact-form.form.message-type')"
						required
						class="w-100 form-radius pointer"
						:class="{ 'activate-validation': fieldErrors.messageType }"
						@click="showMessageTypesMenu = !showMessageTypesMenu; fieldErrors.messageType = false"
						@blur="!showMessageTypesMenu && (fieldErrors.messageType = !form.messageType)"
					>
						<span v-if="fieldErrors.messageType" class="required-field">{{$t('required-field')}}</span>
						<transition name="fade-slide">
							<div v-if="showMessageTypesMenu" class="message-types-menu mt-1 form-radius">
								<div class="form-radius">
									<div
										v-for="(item, i) in messageTypes"
										:key="item.id"
										class="pointer py-2 message-types-menu-item"
										:class="
											i === 0
												? 'first-menu-item'
												: i === messageTypes.length - 1
													? 'last-menu-item'
													: ''
											"
										@click="selectMessageType(item.typeId)"
									>
										<span class="px-2">
											{{item.messageType}}
										</span>
									</div>
								</div>
							</div>
						</transition>
				</div>

				<!-- message -->
				<div class="col-12 my-2">
					<textarea
						v-model="form.message"
						name="message"
						id="message"
						class="w-100 rounded-3"
						:class="{ 'activate-validation': fieldErrors.message }"
						:placeholder="$t('contact-form.form.message-type')"
						rows="3"
						@input="fieldErrors.message = false"
						@blur="fieldErrors.message = !form.message"
					></textarea>
					<span v-if="fieldErrors.message" class="required-field">{{$t('required-field')}}</span>

				</div>

				<!-- submit button -->
                <div
					class="d-flex w-100 my-2"
					:class="somethingWentWrong ? 'justify-content-between' : 'justify-content-end'"
                >
					<span v-if="successfullySent">{{$t('successfully-sent')}}</span>
					<span v-if="somethingWentWrong" class="text-decoration-underline">{{$t('something-went-wrong')}}</span>
                    <button type="submit" class="pointer button first-button short-button" style="border: none">
						<span v-if="sendFormLoading"><i class="fa-solid fa-spinner fa-spin"></i></span>
                        <span v-else>{{$t('send')}}</span>
                    </button>
                </div>
		</form>
	<!-- </div> -->
</template>

<script>
export default {
	props: {
		isSubmitted: Boolean
	},

	data () {
		return {
			notValid: false,
			showMessageTypesMenu: false,
			sendFormLoading: false,
			successfullySent: false,
			somethingWentWrong: false,
			form: {
				name: '',
				email: '',
				phone: '',
				messageType: null,
				message: ''
			},
			fieldErrors: {
				name: false,
				email: false,
				phone: false,
				messageType: false,
				message: false
			},

			messageTypes: [
				{
					id: 1,
					typeId: 1,
					messageType: this.$t('contact-form.message-types.1'),

				},
				{
					id: 2,
					typeId: 2,
					messageType: this.$t('contact-form.message-types.2'),
				},
				{
					id: 3,
					typeId: 3,
					messageType: this.$t('contact-form.message-types.3'),
				}
			]
		}
	},

	watch: {

	},

	methods: {
		validateForm () {
			let isValid = true;
			// Check each field individually
			Object.keys(this.form).forEach(field => {
				this.fieldErrors[field] = !this.form[field]; // true if empty
				if (this.fieldErrors[field]) isValid = false;
			});

			return isValid;
		},
		submitForm () {
			if (this.validateForm()) {
				this.sendFormLoading = true
				// Form is valid, proceed with submission
				this.$emit('submitForm', this.form)
				console.log(this.isSubmitted)
				if (this.isSubmitted) {
					this.sendFormLoading = false
					this.successfullySent = true
					this.form.name = ''
					this.form.email = ''
					this.form.phone = ''
					this.form.messageType = null
					this.form.message = ''
				} else {
					this.sendFormLoading = false
					this.somethingWentWrong = true
				}
			} else {
			// Validation failed
				console.log('the validation failed...')
			}
		},

		selectMessageType (value) {
			this.form.messageType = this.messageTypes.find(c => c.id === value).messageType
			this.showMessageTypesMenu = false
		}
	},

	mounted () {
		document.addEventListener('click', (event) => {
			const input = document.getElementById('message-type');
			const menu = document.querySelector('.message-types-menu');
			if (!input?.contains(event.target) && !menu?.contains(event.target)) {
				this.showMessageTypesMenu = false;
			}
		});
	},
	beforeDestroy () {
		document.removeEventListener('click', this.closeMenu);
	}
}
</script>

<style lang="scss" scoped>
@import '../scss/vars.scss';

.form-radius {
	border-radius: 10px;

	.first-menu-item {
		border-radius: 10px 10px 0 0;
	}

	.last-menu-item {
		border-radius: 0 0 10px 10px;
	}
}

input, textarea {
	border: 1px solid #dadada;
	background-color: #FAFAFA;
	margin-bottom: 12px;
	padding: 11px 18px;
}
input:focus, textarea:focus {
	border: 1px solid $secondary !important;
	outline: none;
}

.activate-validation {
	border: 2px solid red;
}
.required-field {
	color: red;
	font-size: 14px;
}

// message types menu
.message-types-menu {
	position: absolute;
	left: 0;
	width: 99%;
	overflow-x: hidden;
	background-color: white;
	border: 1px solid #ddd;
	.message-types-menu-item {
		transition: background-color 0.1s ease, color 0.1s ease, transform 0.1s ease;
	}

	.message-types-menu-item:hover {
		background-color: $secondary;
		color: white;
	}
}

// message types menu animation
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

// hide spin button for number input:
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

// place holder font size
/* Target ALL input placeholders */
input::placeholder, textarea::placeholder {
  font-size: 14px;  /* Your desired font size */
  color: #999;      /* Optional: Placeholder color */
  opacity: 1;       /* Fix Firefox default opacity */
}

/* Browser prefixes for full compatibility */
input::-webkit-input-placeholder, textarea::-webkit-input-placeholder { /* Chrome/Safari */

  font-size: 14px;
}
input::-moz-placeholder, textarea::-moz-placeholder { /* Firefox */
  font-size: 14px;
}
input:-ms-input-placeholder, textarea:-ms-input-placeholder { /* IE/Edge */

  font-size: 14px;
}
</style>